import { createSelector } from 'reselect';
import { prop, filter, anyPass, groupBy, values, compose, sortBy, path, length, pipe } from 'ramda';
import moment from 'moment';

import {
  isStatusPending,
  isStatusPendingAlt,
  isStatusPendingUserAltConfirm,
  isStatusConfirmed,
  isStatusCompleted,
} from '../../shared/utils/itinerary';

export const selectItineraryDomain = prop('itinerary');

export const selectItinerary = createSelector(
  selectItineraryDomain,
  prop('items')
);

export const selectItineraryItemsNumber = createSelector(
  selectItinerary,
  pipe(
    values,
    length
  )
);

export const selectModal = createSelector(
  selectItineraryDomain,
  prop('modal')
);

export const selectIsVisibleModal = createSelector(
  selectModal,
  prop('isVisible')
);

export const selectModalName = createSelector(
  selectModal,
  prop('experienceName')
);

export const selectModalBookingId = createSelector(
  selectModal,
  prop('bookingId')
);

export const selectIsCancelling = createSelector(
  selectItineraryDomain,
  prop('isCancelling')
);

export const selectCompletedItinerary = createSelector(
  selectItinerary,
  filter(isStatusCompleted)
);

export const selectCompletedItineraryByDate = createSelector(
  selectCompletedItinerary,
  compose(
    sortBy(path(['tickets', 'date'])),
    values
  )
);

export const selectNotCanceledItinerary = createSelector(
  selectItinerary,
  filter(anyPass([isStatusConfirmed, isStatusPending, isStatusPendingAlt, isStatusPendingUserAltConfirm]))
);

const groupByMonthName = groupBy(item => moment.unix(item.tickets.date).format('MMMM'));

export const selectNotCanceledItineraryByDate = createSelector(
  selectNotCanceledItinerary,
  compose(
    groupByMonthName,
    sortBy(path(['tickets', 'date'])),
    values
  )
);

export const selectNotCanceledItineraryLength = createSelector(
  selectNotCanceledItinerary,
  itinerary => Object.keys(itinerary).length
);
